const f = i("start");
function i(o) {
  return e;
  function e(t) {
    const n = t && t.position && t.position[o] || {};
    if (typeof n.line == "number" && n.line > 0 && typeof n.column == "number" && n.column > 0)
      return {
        line: n.line,
        column: n.column,
        offset: typeof n.offset == "number" && n.offset > -1 ? n.offset : void 0
      };
  }
}
export {
  f as pointStart
};
//# sourceMappingURL=index.js.map
